const espaces = document.querySelectorAll('.js-espaces');

if (espaces && espaces.length) {
  const update = () => {
    const search = new URLSearchParams(window.location.search)
    const activeFilter = search.get('cat') ? search.get('cat') : 'all'

    for (let index = 0; index < espaces.length; index++) {
      const espace = espaces[index];

      // set active item
      const activeFilterEl = espace.querySelector(`.js-espaces-filters a[data-espaces-filter="${activeFilter}"]`)
      if (activeFilterEl) {
        const filters = espace.querySelectorAll('.js-espaces-filters a')
        filters.forEach((filter) => {filter.classList.remove('active')})
        activeFilterEl.classList.add('active')
      }

      const items = espace.querySelectorAll('.js-espaces-item');
      items.forEach((item) => item.classList.remove('hide'));
      if (activeFilter !== 'all') {
        const items = espace.querySelectorAll(`.js-espaces-item:not([data-espaces-item="${activeFilter}"])`);
        items.forEach((item) => item.classList.add('hide'))
      }
    }
  }

  const filters = document.querySelectorAll('.js-espaces-filters a')
  filters.forEach((filter) => {
    filter.addEventListener('click', (e) => {
      e.preventDefault()
      const href = filter.getAttribute('href');
      window.history.pushState(null, '', href)
      update();
    })
  })

  window.addEventListener('popstate', () => {
    update();
  })

  update();
}
